"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Spacer = _interopRequireDefault(require("../Spacer"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _OldButtonStyles = require("../OldButton/OldButton-styles");

var _digiwashCore = require("digiwash-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function MeterInput(props) {
  let [meter, setMeter] = (0, _react.useState)(props.defaultValue);
  return /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    type: "number",
    keyboardType: "phone-pad",
    style: {
      width: "60%"
    },
    onChangeText: text => {
      if (text === "") {
        // @ts-ignore farzad will fix
        setMeter("");
      } else if ((0, _digiwashCore.isNumeric)(text)) {
        setMeter(text);
      } else {
        return false;
      }

      return true;
    },
    value: meter === 0 ? null : `${meter}`,
    placeholder: "\u0645\u062A\u0631\u0627\u0698 \u06A9\u0644 \u067E\u0631\u062F\u0647 \u0647\u0627 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F"
  }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    size: "m"
  }), /*#__PURE__*/_react.default.createElement(_OldButtonStyles.Button, {
    disabled: meter == 0 || !meter,
    bg: "green.main",
    size: "m",
    type: "circle-like",
    onPress: () => {
      // @ts-ignore farzad will fix
      props.onSubmit(meter);
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "common.white"
  }, "\u062B\u0628\u062A \u0645\u062C\u0645\u0648\u0639 \u0645\u062A\u0631\u0627\u0698")));
}

var _default = MeterInput;
exports.default = _default;